// src/components/PlantaDashboard.js
import React, { useState, useEffect } from 'react';
import {
  TextField,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  Box,
CircularProgress,
} from '@mui/material';
import {
  StyledMainContainer,
  StyledHeaderWrapper,
  StyledPageTitle,
  StyledTableContainer,
  StyledTableHeaderCell,
  StyledNoUsersCell,
  StyledPaper,
  StyledActionsBar,
  StyledTableLinkCell
} from './StyleComponents';
import SearchIcon from '@mui/icons-material/Search';

import Header from './Header';
import PlantaDetailForm from './PlantaDetail';
import api from './api';

function PlantaDashboard() {
  const [openPlantaDetail, setOpenPlantaDetail] = useState(false);
  const [selectedPlanta, setSelectedPlanta] = useState(null);
  const [plantas, setPlantas] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPlantas();
  }, []);

  const fetchPlantas = async () => {
    try {
      setLoading(true);
      const response = await api.get('/plantas/?skip=0&limit=1000');
      setPlantas(response.data);
    } catch (error) {
      console.error('Error al obtener plantas:', error);
    }
    finally {
     setLoading(false);
   }

  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleCreatePlant = () => {
    setSelectedPlanta(null);
    setOpenPlantaDetail(true);
  };

  const handleEditClick = (plant) => {
    setSelectedPlanta(plant);
    setOpenPlantaDetail(true);
  };

  const handleClosePlantaDetail = () => {
    setOpenPlantaDetail(false);
    setSelectedPlanta(null);
  };

  const handleSavePlanta = (updatedPlantaData) => {
    setPlantas((prev) => {
      const index = prev.findIndex(p => p.id === updatedPlantaData.id);
      if (index >= 0) {
        const newList = [...prev];
        newList[index] = updatedPlantaData;
        return newList;
      } else {
        return [...prev, updatedPlantaData];
      }
    });
    handleClosePlantaDetail();
  };

  const filteredPlants = plantas
  .filter((plant) => {
    const term = searchTerm.toLowerCase();
    return (
      (plant.nombre?.toLowerCase().includes(term)) ||
      (String(plant.determinante)?.includes(term)) ||
      (plant.fabricante?.nombre?.toLowerCase().includes(term)) || 
      (plant.zona?.nombre?.toLowerCase().includes(term)) ||
      ((plant.is_active ? 'activo' : 'inactivo').includes(term))
    );
  })
  .sort((a, b) => (a.nombre || '').localeCompare(b.nombre || ''));


  return (
    <StyledMainContainer>
      <Header />
      <StyledHeaderWrapper>
        <StyledPageTitle variant="h4" component="h1" gutterBottom>
          Plantas
        </StyledPageTitle>
      </StyledHeaderWrapper>

      <StyledActionsBar>
        <TextField
          label="Filtrar por nombre, estatus, fabricante, etc"
          variant="outlined"
          fullWidth
          size="small"
          value={searchTerm}
          onChange={handleSearchChange}
          InputProps={{
            endAdornment: (
              <IconButton>
                <SearchIcon />
              </IconButton>
            ),
          }}
        />
        <Button variant="contained" sx={{ whiteSpace: 'nowrap', minWidth: '150px' }} onClick={handleCreatePlant}>
          Crear Planta
        </Button>
      </StyledActionsBar>
          {loading ? (
    <Box display="flex" justifyContent="center" alignItems="center" height="200px">
      <CircularProgress />
    </Box>
  ) : (
      <StyledTableContainer component={StyledPaper} elevation={1}>
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableHeaderCell>Determinante</StyledTableHeaderCell>
              <StyledTableHeaderCell>Nombre</StyledTableHeaderCell>
              <StyledTableHeaderCell>Fabricante</StyledTableHeaderCell>
              <StyledTableHeaderCell>Cliente</StyledTableHeaderCell>
              <StyledTableHeaderCell>Zona</StyledTableHeaderCell>
              <StyledTableHeaderCell>Activo</StyledTableHeaderCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredPlants.length > 0 ? (
              filteredPlants.map((plant) => (
                <TableRow key={plant.id}>
                  <TableCell>{plant.determinante}</TableCell>
                  <StyledTableLinkCell onClick={() => handleEditClick(plant)}>
                    {plant.nombre || '-'}
                  </StyledTableLinkCell>
                  <TableCell>{plant.fabricante?.nombre || '-'}</TableCell>
                  <TableCell>{plant.cliente?.nombre || '-'}</TableCell>
                  <TableCell>{plant.zona?.nombre || '-'}</TableCell>
                  <TableCell>{plant.is_active ? 'Activo' : 'Inactivo'}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <StyledNoUsersCell colSpan={6}>No se encontraron plantas.</StyledNoUsersCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </StyledTableContainer>
      )}

      <PlantaDetailForm
        open={openPlantaDetail}
        onClose={handleClosePlantaDetail}
        planta={selectedPlanta}
        onSave={handleSavePlanta}
      />
    </StyledMainContainer>
  );
}

export default PlantaDashboard;
